<template>
  <main>
    <section class="page_404">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 text-center">
            <div class="four_zero_four_bg">
              <h1 class="text-center">404</h1>
            </div>
            <div class="contant_box_404">
              <h3 class="h2">يبدو أنك تائه</h3>
              <p>الصفحة التي تبحث عنها غير متوفرة!</p>
              <router-link class="btn view" to="/">ارجع الى الخلف</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {};
</script>
<style  lang="scss">
.page_404 {
  background: var(--bg-app);
  color: var(--text-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  .four_zero_four_bg {
    background-image: url("@/assets/Notfound.gif");
    height: 400px;
    background-position: center;
    background-repeat: no-repeat;
    h1 {
      font-size: 80px;
    }
    h3 {
      font-size: 80px;
    }
  }
  .contant_box_404 {
    margin-top: -50px;
  }
}

@media only screen and (max-width: 575.98px) {
  .four_zero_four_bg {
    background-size: cover;
  }
}
</style>